const config = {
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  maxFileSize: 10 * 1024 * 1024, // 10MB
  maxFiles: 1000,
  compressionOptions: {
    maxSizeMB: 5,
    maxWidthOrHeight: 2048,
    useWebWorker: true,
  },
  imageQuality: 0.9,
  supportedFormats: ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/heic'],
};

export default config;

